// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_ml-2";
export var interactiveWrapper = "_ml-0";
export var shippingHoverPreview = "_ml-4";
export var summaryBadgeTrigger = "_ml-1";
export var widgetHoverPreviewList = "_ml-3";
export var widgetPreviewScale = "_ml-5";